<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        v-if="!editable && editMode"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>{{ title }}</strong>
    </div>
    <div
      v-if="editable"
      class="card-body">
      
      <form v-on:submit.prevent="save(candidateEdit)">  
        <div 
          class="form-group" 
          v-for="(field, field_index) in fields"
          :key="field_index">    
          <label class="control-label">{{ field.label }}</label>
          <input-custom-field
            :type = "field.type"
            :options = "field.options"
            v-model="candidateEdit.custom_fields[field.key]">
            </input-custom-field>
            <!--<ValidateMessage :error="validateErrors.salary" />-->
        </div>

        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>
      </form>
      
    </div>
    <div
      v-if="!editable"
      class="card-body">
      
      <div
        class="row mb-2"
        v-for="(field, field_index) in fields"
        :key="field_index"
        v-if="editMode || (candidate.custom_fields && candidate.custom_fields[field.key])">
        <div class="col-sm-3">
          <strong>{{ field.label }}</strong>
        </div>
        <div class="col-sm-9">
          <value-custom-field 
            v-if="candidate.custom_fields && candidate.custom_fields[field.key]"
            :type="field.type"
            :options="field.options"
            :value="candidate.custom_fields[field.key]">
            </value-custom-field>
          <div
            v-if="!(candidate.custom_fields && candidate.custom_fields[field.key])">
            --
            </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import InputCustomField from '@/components/Fields/InputCustomField'
import ValueCustomField from '@/components/Parts/ValueCustomField'

export default {
  name: 'CandidateProfileCustomFields',
  components: {
    InputCustomField,
    ValueCustomField
  },
  props: [
    'title',
    'fields',
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    filled () {
      return this.fields.filter((field) => {
        return this.candidate.custom_fields && this.candidate.custom_fields[field.key]
      }).length
    }
  },
  methods: {
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = {
        _id: this.candidate._id,
        custom_fields: this.candidate.custom_fields ? this.candidate.custom_fields : {}
      }
    },
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileCustomFields.vue